import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import { ToastProvider } from './components/ui/Toast';

// Sentry init runs only when a DSN is configured at build time
// (set in frontend/.env.production). Local dev `npm start` leaves it off.
// No personal data is sent: minors' names/birth dates may appear in requests (FL-42).
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    sendDefaultPii: false,
    beforeBreadcrumb(breadcrumb) {
      // console breadcrumbs can contain API payloads - keep only the message level
      if (breadcrumb.category === 'console') return null;
      return breadcrumb;
    },
  });
}

function CrashScreen() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 p-6">
      <div className="max-w-md rounded-lg bg-white p-6 text-center shadow">
        <h1 className="text-xl font-semibold text-gray-900">Něco se pokazilo</h1>
        <p className="mt-2 text-gray-600">
          Zkuste prosím stránku načíst znovu. Pokud používáte automatický překlad stránky, vypněte ho.
          Chyba byla automaticky nahlášena.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="mt-4 rounded-md bg-indigo-600 px-4 py-2 text-white hover:bg-indigo-700"
        >
          Načíst znovu
        </button>
      </div>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Sentry.ErrorBoundary fallback={<CrashScreen />}>
    <Router>
      <ToastProvider>
        <App />
      </ToastProvider>
    </Router>
  </Sentry.ErrorBoundary>
);
